module.exports = __webpack_public_path__ + "assets/tx-icon.09cd11fd.svg";